// Přístup lidí k firmám — části potřebné mimo obrazovku Uživatelé a role
// (Firmy, Plány, jména), aby se users.js mohl načítat až při otevření.
import { ROLE_LABELS, esc, nonAdminRoleIds, roleAllCompanies, roleHasCompany, state } from './state.js';
import { userCap } from './boot.js';
import { settingsSectionHtml } from './ui-kit.js';
import { personDisplayName } from '../views/schedule.js';
import { render } from '../main-render.js';

// ================= USERS & ROLES (administrátor) =================
function ensureRoleProfiles(){
  if(!userCap) return;
  var ids = Array.from(state.roles.keys());
  if(state.myId && ids.indexOf(state.myId)===-1) ids.push(state.myId);
  var key = ids.slice().sort().join(',');
  if(key === state.roleProfilesKey) return;
  state.roleProfilesKey = key;
  if(ids.length===0){ state.roleProfiles = {}; return; }
  userCap.profiles(ids).then(function(ps){
    state.roleProfiles = ps;
    render();
  });
}
function accessName(id){ return userDisplayNameFor(id) || personDisplayName(id); }
// E: v Nastavení → Firmy — kolik lidí firmu vidí a kdo.
function companyAccessSummary(cid){
  var n = nonAdminRoleIds().filter(function(id){ return roleHasCompany(state.roles.get(id), cid); }).length;
  if(n===0) return 'Vidí jen administrátoři';
  return 'Vidí '+n+' '+(n===1?'uživatel':n<=4?'uživatelé':'uživatelů')+' + administrátoři';
}
function companyWhoSeesHtml(cid){
  ensureRoleProfiles();
  var people = nonAdminRoleIds();
  var html = settingsSectionHtml('Kdo vidí tuto firmu') + '<div class="card">';
  if(people.length===0){
    html += '<div class="muted" style="font-size:var(--fs-base)">Zatím nemáte žádného Uživatele ani Správce. Administrátoři vidí všechny firmy.</div>';
  } else {
    people.forEach(function(id){
      var r = state.roles.get(id);
      var all = roleAllCompanies(r);
      html += '<label class="check-row"><input type="checkbox" '+(roleHasCompany(r, cid)?'checked':'')+' disabled/>' +
        '<span>'+esc(accessName(id))+' <span class="muted" style="font-size:var(--fs-sm)">· '+esc(ROLE_LABELS[r.role]||ROLE_LABELS.user)+(all?' · všechny firmy':'')+'</span></span></label>';
    });
  }
  return html + '</div>';
}

function userDisplayNameFor(id){
  var prof = state.roleProfiles[id];
  return (prof && prof.name) || '';
}

// Kód druhu auditu (zobrazení) — používá i probíhající audit.
function auditTypeFullCode(t){ return (t && t.code) ? ((t.companyId ? '' : 'S-') + t.code) : ''; }
function auditTypeMissingCodeMsg(t){
  return 'Druh auditu „'+((t&&t.name)||'')+'“ nemá kód. Doplní ho Administrátor nebo Správce v Nastavení → Druhy auditů a otázky.';
}

export { accessName, auditTypeFullCode, auditTypeMissingCodeMsg, companyAccessSummary, companyWhoSeesHtml, ensureRoleProfiles, userDisplayNameFor };
